import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const Madrasa = {
  id: "42",
  name: "Madrasa",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Madrasa",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Madrasa',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          0,0,10,10,10,10,22,22,22,22,22,30,30,30,34,34,34,34,34,40,40,40,40,40,46,46,46,46,46,46,52,52,52,52,56,56,56,56,56,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80
        ],
        bronzeAge: [
          0,0,20,20,20,20,40,40,40,40,40,56,56,56,64,64,64,64,64,76,76,76,76,76,86,86,86,86,86,86,98,98,98,98,106,106,106,106,106,114,116,118,120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,154
        ],
        minoanEra: [
          0,0,30,30,30,30,58,58,58,58,58,82,82,82,94,94,94,94,94,110,110,110,110,110,126,126,126,126,126,126,144,144,144,144,154,154,154,154,154,168,171,175,178,182,185,189,192,196,199,203,206,210,213,217,220,224,227,231,234,238
        ],
        classicGreece: [
          0,0,40,40,40,40,78,78,78,78,78,108,108,108,122,122,122,122,122,146,146,146,146,146,166,166,166,166,166,166,190,190,190,190,204,204,204,204,204,222,226,231,235,240,244,249,253,258,262,267,271,276,280,285,289,294,298,303,307,312
        ],
        earlyRome: [
          0,0,50,50,50,50,96,96,96,96,96,134,134,134,152,152,152,152,152,182,182,182,182,182,206,206,206,206,206,206,236,236,236,236,254,254,254,254,254,274,279,284,289,294,299,304,309,314,319,324,329,334,339,344,349,354,359,364,369,374
        ],
        romanEmpire: [
          0,0,60,60,60,60,116,116,116,116,116,160,160,160,182,182,182,182,182,216,216,216,216,216,248,248,248,248,248,248,282,282,282,282,302,302,302,302,302,328,334,341,347,354,360,367,373,380,386,393,399,406,412,419,425,432,438,445,451,458
        ],
        byzantineEra: [
          0,0,70,70,70,70,134,134,134,134,134,186,186,186,212,212,212,212,212,252,252,252,252,252,288,288,288,288,288,288,328,328,328,328,352,352,352,352,352,382,389,397,404,412,419,427,434,442,449,457,464,472,479,487,494,502,509,517,524,532
        ],
        ageOfTheFranks: [
          0,0,80,80,80,80,152,152,152,152,152,210,210,210,242,242,242,242,242,286,286,286,286,286,328,328,328,328,328,328,372,372,372,372,400,400,400,400,400,434,442,451,459,468,476,485,493,502,510,519,527,536,544,553,561,570,578,587,595,604
        ],
        feudalAge: [
          0,0,90,90,90,90,172,172,172,172,172,236,236,236,270,270,270,270,270,322,322,322,322,322,368,368,368,368,368,368,418,418,418,418,450,450,450,450,450,488,497,507,516,526,535,545,554,564,573,583,592,602,611,621,630,640,649,659,668,678
        ],
        iberianEra: [
          0,0,100,100,100,100,190,190,190,190,190,260,260,260,298,298,298,298,298,354,354,354,354,354,404,404,404,404,404,404,460,460,460,460,496,496,496,496,496,536,546,556,566,576,586,596,606,616,626,636,646,656,666,676,686,696,706,716,726,736
        ],
        kingdomOfSicily: [
          0,0,110,110,110,110,210,210,210,210,210,286,286,286,328,328,328,328,328,390,390,390,390,390,444,444,444,444,444,444,506,506,506,506,546,546,546,546,546,590,601,612,623,634,645,656,667,678,689,700,711,722,733,744,755,766,777,788,799,810
        ],
        highMiddleAges: [
          0,0,121,121,121,121,231,231,231,231,231,315,315,315,361,361,361,361,361,429,429,429,429,429,488,488,488,488,488,488,557,557,557,557,601,601,601,601,601,649,661,673,685,697,709,721,733,745,757,769,781,793,805,817,829,841,853,865,877,889
        ],
        earlyGothicEra: [
          0,0,140,140,140,140,250,250,250,250,250,326,326,326,365,365,365,365,365,430,430,430,430,430,495,495,495,495,495,495,573,573,573,573,625,625,625,625,625,690,703,716,729,742,755,768,781,794,807,820,833,846,859,872,885,898,911,924,937,950
        ],
        lateGothicEra: [
          0,0,147,147,147,147,262,262,262,262,262,342,342,342,383,383,383,383,383,451,451,451,451,451,519,519,519,519,519,519,601,601,601,601,655,655,655,655,655,723,752,766,780,794,808,822,836,850,864,878,892,906,920,934,948,962,976,990,1004,1018
        ]
      }),
      CultureRange.asPerLevel([
        0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
        2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 3
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        1.25, 1.25, 1.25, 1.25, 1.25, 1.65, 1.65, 1.65, 2.05, 2.55,
        2.55, 2.55, 2.55, 2.80, 2.80, 3.10, 3.10, 3.10, 3.30, 3.30,
        3.30, 3.55, 3.55, 3.90, 3.90, 4.65, 4.65, 4.65, 5.20, 5.40,
        5.40, 5.40, 6.10, 6.10, 6.10, 6.10, 6.10, 6.60, 7.10, 7.10,
        7.10, 7.10, 7.10, 7.10, 7.10, 7.10, 7.10, 7.10, 7.10, 7.10,
        7.10, 7.10, 7.10, 7.10, 7.10, 7.10, 7.10, 7.10, 7.10, 7.10
      ]).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asCallbackWithLevel(
          (level) => level === 1 ? 0 : 1
        )
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include food or barracks refill'),
    ),
  ]),
};

export default Madrasa;
